module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-bottom": "2px solid #007acc"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "10px",
      "color": "#666'",
      "font-size": "14px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "demo-table-expand",
    attrs: {
      "label-position": "left",
      "inline": ""
    }
  }, [_c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$仓库') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.Warehouse ? (_vm.data.Warehouse.EnName + '-' + _vm.data.Warehouse.CnName) : ''))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$收件人') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.ConsigneeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$邮编') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.Zipcode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$州') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.Add_State))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$城市') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.City))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$地址') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.Address1) + " " + _vm._s(_vm.data.Address2))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$电话') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.Contact))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$票件数') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.BillQty))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$跟踪号') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.TrackingNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$订单备注') + ':'
    }
  }, [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.data.CusRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$标发状态') + ':'
    }
  }, [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.data.IsPlatFormTrackFlag ? "YES" : "NO"))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$订单名称') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.name))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$订单来源状态') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.processing_method))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$税号') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.DutyNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$实际重量') + ':'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.ActualWeight))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$系统备注') + ':'
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.data.SysRemark))])]), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticClass: "lineHeight",
    attrs: {
      "label": _vm.gets('$错误信息') + ':'
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.data.ErrorMessage))])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('table', {
    staticStyle: {
      "margin": "0 0 10px"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%",
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "id": "ProductUrl"
    }
  }, [_vm._v(_vm._s(_vm.gets('$产品图片')))]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "SKU3"
    }
  }, [_vm._v(_vm._s(_vm.gets('SKU')))]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "sSKU3"
    }
  }, [_vm._v(_vm._s(_vm.gets('$平台SKU')))]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "Amount"
    }
  }, [_vm._v(_vm._s(_vm.gets('$数量')))]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "USD"
    }
  }, [_vm._v(_vm._s(_vm.gets('$申报价值')) + " ")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.data.OrderDetails), function(i) {
    return _c('tr', [_c('td', [_c('el-popover', {
      attrs: {
        "placement": "right",
        "title": "",
        "trigger": "hover"
      }
    }, [_c('img', {
      attrs: {
        "src": i.ImgUrl
      }
    }), _vm._v(" "), _c('img', {
      staticStyle: {
        "max-height": "100px",
        "max-width": "100px"
      },
      attrs: {
        "slot": "reference",
        "src": i.ImgUrl
      },
      slot: "reference"
    })])], 1), _vm._v(" "), _c('td', [_c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(_vm._s(i.Product == null ? (i.EnName + "-" + i.CnName) : (i.Product.EnName + "-" + i.Product.CnName)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(i.SKU))])])], 1), _vm._v(" "), _c('td', [_c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(_vm._s((i.ShopProduct == null || i.ShopProduct.Title == null) ? i.EnName : i.ShopProduct.Title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(i.ShopSKU))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.Quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(i.SinglePrice))]), _vm._v(" "), _c('td', [(!i.Product && _vm.UserContext.UserType != 0 && i.ShopProduct) ? _c('span', {
      style: ({
        marginRight: '5px'
      }),
      attrs: {
        "type": "success",
        "size": "mini"
      }
    }, [_vm._v(_vm._s(_vm.gets('$未绑定')))]) : _vm._e()])])
  })], 2)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752c123c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/Order/OrderTableExpandComponent1.vue
// module id = 1294
// module chunks = 169